import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
export const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    component: () => import("@/layout/index.vue"),
    redirect: () => ({
       name: "ClearStart"

    }),
    children: [
      {
        path: "main",
        name: "Main",
        component: () => import("@/views/main.vue")
      },
      {
        path: "add",
        name: "Add",
        component: () => import("@/views/add/index.vue")
      },
      {
        path: "clear-record",
        name: "ClearRecord",
        component: () => import("@/utils/router-view"),
        children: [
          {
            path: "clear-list",
            name: "ClearList",
            component: () => import("@/views/clearRecord/index.vue")
          },
          {
            path: "clear-detail",
            name: "ClearDetail",
            component: () => import("@/views/clearRecord/detail.vue")
          },
          //qwe
          // {
          //   path: "clear-start",
          //   name: "ClearStart",
          //   component: () => import("@/views/add/components/Start.vue")
          // },
          {
            path: "clear-start",
            name: "ClearStart",
            redirect: { name: "ClearList", query: { active: "1" } }
          }
          // {
          //   path: "clear-result",
          //   name: "ClearResult",
          //   component: () => import("@/views/add/components/ClearResultTable.vue")
          // }
        ]
      },
      {
        path: "compose",
        name: "Compose",
        component: () => import("@/utils/router-view"),
        redirect: { name: "ComposeList" },
        children: [
          {
            path: "list",
            name: "ComposeList",
            component: () => import("@/views/compose/list.vue"),
            meta: { title: "我的项目" }
          },
          {
            path: "create",
            name: "ComposeCreate",
            component: () => import("@/views/compose/create.vue"),
            meta: { title: "新建项目" }
          },
          {
            path: "detail",
            name: "ComposeDetail",
            component: () => import("@/views/compose/detail.vue"),
            meta: { title: "项目详情" }
          }
        ]
      },
      {
        path: "user",
        name: "User",
        redirect: () => {
          return {
            name: "QbList"
          };
        },
        component: () => import("@/views/user/index.vue"),
        children: [
          {
            path: "qb-rule",
            name: "QbRule",
            component: () => import("@/utils/router-view"),
            children: [
              {
                path: "qb-list",
                name: "QbList",
                component: () => import("@/views/user/qb-list.vue"),
                meta: {
                  title: "清标规则管理"
                }
              },
              {
                path: "qb-detail",
                name: "QbDetail",
                component: () => import("@/views/user/qb-detail.vue"),
                meta: {
                  title: "清标规则详情"
                }
              }
            ]
          },
          {
            path: "qb-account",
            name: "QbAccount",
            component: () => import("@/views/user/qb-account.vue"),
            meta: {
              title: "我的账户"
            }
          },
          {
            path: "qb-invitation",
            name: "QbInvitation",
            component: () => import("@/views/user/qb-invitation.vue"),
            meta: {
              title: "推广码"
            }
          },
          {
            path: "qb-liscene",
            name: "QbLiscene",
            component: () => import("@/views/user/qb-liscene.vue"),
            meta: {
              title: "清标额度授权"
            }
          },
          {
            path: "qb-invoice",
            name: "QbInvoice",
            component: () => import("@/views/user/qb-invoice.vue"),
            meta: {
              title: "发票管理"
            }
          },
          {
            path: "qb-package",
            name: "QbPackage",
            component: () => import("@/views/user/qb-package.vue"),
            meta: {
              title: "套餐管理"
            }
          },
          {
            path: "qb-bank-transfer",
            name: "QbBankTransfer",
            component: () => import("@/views/user/qb-bank-transfer.vue"),
            meta: {
              title: "对公转账"
            }
          },
          {
            path: "qb-bank-account",
            name: "QbBankAccount",
            component: () => import("@/views/user/qb-bank-account.vue"),
            meta: {
              title: "收款账户配置"
            }
          },
          {
            path: "qb-coupon",
            name: "QbCoupon",
            component: () => import("@/views/user/qb-coupon.vue"),
            meta: {
              title: "优惠券管理"
            }
          },
          {
            path: "qb-user-manage",
            name: "QbUserManage",
            component: () => import("@/views/user/qb-user-manage.vue"),
            meta: {
              title: "用户管理"
            }
          },
          {
            path: "qb-system-config",
            name: "QbSystemConfig",
            component: () => import("@/views/user/qb-system-config.vue"),
            meta: {
              title: "系统信息配置"
            }
          },
          {
            path: "qb-order-statistics",
            name: "QbOrderStatistics",
            component: () => import("@/views/user/qb-order-statistics.vue"),
            meta: {
              title: "订单统计"
            }
          }
        ]
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/common/login.vue")
  },
  {
    path: "/forget-pwd",
    name: "ForgetPwd",
    component: () => import("@/views/common/forgetpwd.vue")
  },
  {
    path: "/update-pwd",
    name: "UpdatePwd",
    component: () => import("@/views/common/UpdatePwd.vue")
  },
  { path: "/:pathMatch(.*)*", component: () => import("../views/404.vue"), children: [] }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
